import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subscription } from 'rxjs';
import { ResponseData } from 'src/app/Model/Base/Response';
import { CountryModel } from 'src/app/Model/Country.model';
import { ParametersModel } from 'src/app/Model/Parameter.model';
import { RegionModel } from 'src/app/Model/Region.model';
import { RequestModel } from 'src/app/Model/Request.model';
import { RequestLocationModel } from 'src/app/Model/RequestLocation.model';
import { VRequestStatusProcessModel } from 'src/app/Model/VRequestStatusProcess.Model';
import { SessionStorageService } from 'src/app/Services/sessionStorageService/session-storage.service';
import { ComService } from 'src/app/Services/com-service/com.service';
import { crmGeoService } from 'src/app/Services/crm-geo-service/crm-geo-service.service';
import { RequestService } from 'src/app/Services/request/request.service';
import Swal from 'sweetalert2';
import { map, startWith } from 'rxjs/operators';
import { Flows } from 'src/app/Model/Enums/Flow.enums';

@Component({
  selector: 'app-agency-location',
  templateUrl: './agency-location.component.html',
  styleUrls: ['./agency-location.component.css']
})
export class AgencyLocationComponent implements OnInit {
  @Input() request: RequestModel;
  @Input() lstStatuses: VRequestStatusProcessModel[];
  @Input() lstLanguages: ParametersModel[];
  allowEdit:boolean
  public isMobile = false;
  newRequest: RequestModel;
  @Output() newRequestEvent = new EventEmitter<number>();
  lstCountries: CountryModel[];
  requestLocation: RequestLocationModel;
  hideSaveButton: boolean = false;
  selectedRegion: RegionModel;
  selectedCountry: CountryModel;
  @ViewChild('popUp',{static: false})
  popUp: ElementRef;
  options: string[] = []
  filteredOptions:Observable<string[]>;

  form = new FormGroup({
    city: new FormControl('', [Validators.required]),
    Language: new FormControl('', [Validators.required]),
    LanguageName: new FormControl('',[]),
    CityName: new FormControl('',[])
  });

  notifierSubscription: Subscription = this.dataService.componentUpdateNotifier.subscribe(notified => {
    // originator has notified me. refresh my data here.
    this.ngOnInit()
  });

  @Output() nextEvent = new EventEmitter();
  nextStep() {
    if (this.requestLocation == null || this.requestLocation.Id == null)
      Swal.fire({
        title: this.translate.instant('Request.Messages.ContinueNextTitle'),
        text: this.translate.instant('Request.Messages.ContinueNext'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('Request.Label.Yes'),
        cancelButtonText: this.translate.instant('Request.Label.No')

      }).then((result) => {
        if (result.isConfirmed) {
          this.nextEvent.emit();
        }
      })
    else
      this.nextEvent.emit();
  }
  @Output() prevEvent = new EventEmitter();
  prevStep() {
    this.prevEvent.emit();
  }
  constructor(private readonly requestService: RequestService,
    private readonly translate: TranslateService,
    private readonly spinner: NgxSpinnerService,
    private readonly crmGeoService: crmGeoService,
    private readonly dataService: ComService,
    private readonly lsService : SessionStorageService) {

    }

  async ngOnInit() {
    let idrequest = this.lsService.getLSItem("IdRequest");
    let rq = await this.requestService.getRequestById(idrequest);
    if(rq != null && rq.RequestLocation[0] != undefined)
    {
      this.requestLocation = rq.RequestLocation[0]
      this.requestLocation.Id = rq.RequestLocation[0].Id
      if(this.request.IsNewIata && this.requestLocation.IdLanguage == null){
        this.requestLocation.CityId = null
      }
    }
    else
    {
      this.requestLocation.Id = 0
    }

    this.loadCities();

    this.filteredOptions = this.city.valueChanges.pipe(
      startWith(''),
      map(value => (value != undefined && value != "") ? value.length != 1 ? value.length >= 2 ? this._filter(value || '') : [] : this.options : this.options),
    )
  }
  ngOnDestroy() {
    this.notifierSubscription.unsubscribe();
  }
  ngOnChanges() {
    this.city.enable();
    this.Language.enable();
    this.allowEdit= this.lstStatuses.some(x=>x.IdComponent==4)
    if (this.requestLocation == null || (this.requestLocation.Id == null && this.request.RequestLocation != null && this.request.RequestLocation.length > 0)) {
      this.newRequest = Object.assign({}, this.request);
      if (this.newRequest != null && this.newRequest.RequestLocation != null && this.newRequest.RequestLocation.length > 0) {
        {
          this.requestLocation = this.newRequest.RequestLocation[0];
          if(this.request.IsNewIata && this.requestLocation.IdLanguage == null){
            this.requestLocation.CityId = null
          }
        }
      }
      else
        this.requestLocation = new RequestLocationModel();
    }
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if (this.request != null && this.request.RequestStatus != null && !this.allowEdit) {
      this.city.disable();
      this.Language.disable();
    }
    else if(this.request != null && syncFlows.has(this.request.IdFlow)){
      this.city.disable();
      this.Language.disable();
    }
  }

  async onSubmit(): Promise<void> {

    this.hideSaveButton = true;
    this.spinner.show();
    if(this.requestLocation == null){
      this.requestLocation.Id = 0
    }

    this.requestLocation.IdRequest = this.request.Id
    let res: ResponseData;
    await this.requestService.postLocation(this.requestLocation).then(resp => {
      res = resp;
    })

    if (res.head.status.toLowerCase() == 'true') {
      let json: RequestLocationModel = JSON.parse(res.body.response);
      this.requestLocation = json;
      this.newRequestEvent.emit(this.request.Id);
      await Swal.fire({
        html: this.popUp.nativeElement,
        width: 300,
        showCloseButton: true,
        showConfirmButton: false,

      }).then(res => {
        this.hideSaveButton = false;
        this.nextStep();
      })
    }
    else {
      this.hideSaveButton = false;
      this.spinner.hide();
      if(res.head.error.description.includes("Error de PlantillaOID")){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving6'),
          icon: 'error'
        })
      }
      else if(res.head.error.description.includes("a la información registrada.")){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving1'),
          icon: 'error'
        })
      }
      else if(res.head.error.description.includes("El Iata actualmente tiene Ticketing Authority")){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving3'),
          icon: 'error'
        })
      }
      else if(res.head.error.description.includes("El IATA no tiene Ticketing Authority")){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving4'),
          icon: 'error'
        })
      }
      else if(res.head.error.description.includes("El país seleccionado está por fuera de Colombia")){
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving5'),
          icon: 'error'
        })
      }
      else if(res.head.error.description.includes("El flujo seleccionado no esta activo.")){
        this.hideSaveButton = false;
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving2'),
          icon: 'error'
        })
      }
      else{
        await Swal.fire({
          title: 'Error!',
          text: this.translate.instant('Request.Messages.ErrorSaving'),
          icon: 'error'
        })
      }
    }

  }

  SelectLanguage(event,evt)
  {
    if(event.isUserInput){
      if(this.requestLocation != undefined)
      {
        this.requestLocation.IdLanguage = evt.Value
        this.requestLocation.LanguageName = evt.Description
      }
    }
    
  }

  SelectCity(evt, event){
    if(event.isUserInput){
      const selectedCountry = this.lstCountries.find(x => x.Name === evt);
      if (selectedCountry) {
      this.requestLocation.CityId = selectedCountry.Code;
      this.requestLocation.CityName = selectedCountry.Name;
      this.requestLocation.CityCode = selectedCountry.Iata;
      this.requestLocation.IdCityGeo = selectedCountry.IdCityGeo;
      }
    }
  }

  async loadCities() {
    await this.crmGeoService.getCity().then(res => {
      this.lstCountries = res;
      this.lstCountries.forEach(element => {
        if(!this.options.includes(element.Name)){
          this.options.push(element.Name)
        }
      });
    });
  }

  public disableOptions(): boolean{
    const syncFlows = new Set([Flows.Flujo3_1,Flows.Flujo3_2,Flows.Flujo4_1,Flows.Flujo4_2,Flows.Flujo6_1,Flows.Flujo6_2])
    if(this.request != null && syncFlows.has(this.request.IdFlow)){
      return true
    }
    else
      return this.form.invalid || (this.request!=null && this.request.RequestStatus!=null && !this.allowEdit)
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.options.filter(option => option.toLowerCase().startsWith(filterValue));
  }

  get city() { return this.form.get('city'); }
  get Language() { return this.form.get('Language'); }
  get LanguageName() { return this.form.get('LanguageName'); }
  get CityName() { return this.form.get('CityName'); }

}
